import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';
import { broadcastLogout, listenCrossTabLogout } from '../utils/crossTabAuthSync';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('employer_user') || localStorage.getItem('portal_user') || localStorage.getItem('user');
    try {
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [token, setToken] = useState(() => {
    const raw = localStorage.getItem('employer_token') || localStorage.getItem('staff_token') || localStorage.getItem('token') || '';
    return (raw && raw !== 'true' && raw !== 'false' && raw !== 'null' && raw !== 'undefined' && raw.length > 20) ? raw : '';
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
    const unsubscribe = listenCrossTabLogout(() => {
      setUser(null);
      setToken('');
      if (window.location.pathname.startsWith('/portal/employer')) {
        window.location.href = '/portal/login';
      }
    });
    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post('/api/employers/login/', { email, password });
      const { user: userData, token: tokenData } = response.data;

      setUser(userData);
      const cleanToken = (tokenData && tokenData !== 'true' && tokenData.length > 20) ? tokenData : '';
      if (cleanToken) {
        setToken(cleanToken);
        localStorage.setItem('employer_token', cleanToken);
        localStorage.setItem('token', cleanToken);
      } else {
        localStorage.removeItem('employer_token');
      }
      localStorage.setItem('employer_user', JSON.stringify(userData));

      return { success: true };
    } catch (error) {
      console.error('Login failed:', error);
      return { success: false, error: error.response?.data?.error || 'Login failed' };
    }
  };

  const loginWithToken = (userData, tokenStr) => {
    setUser(userData);
    const cleanToken = (tokenStr && tokenStr !== 'true' && tokenStr.length > 20) ? tokenStr : '';
    if (cleanToken) {
      setToken(cleanToken);
      localStorage.setItem('employer_token', cleanToken);
      localStorage.setItem('token', cleanToken);
    } else {
      localStorage.removeItem('employer_token');
    }
    localStorage.setItem('employer_user', JSON.stringify(userData));
  };

  const logout = () => {
    try { api.post('/api/logout/').catch(() => {}); } catch (e) {}
    setUser(null);
    setToken('');
    broadcastLogout('employer');
  };

  const cleanCurrentToken = (token && token !== 'true' && token.length > 20) ? token : '';

  const value = {
    user,
    token: cleanCurrentToken,
    loading,
    login,
    logout,
    loginWithToken,
    isAuthenticated: Boolean(user || localStorage.getItem('employer_user'))
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
